import React, { ReactNode, FC, ChangeEvent, memo, FocusEvent } from 'react'
import { TextInput } from 'components/atoms'
import { Autocomplete } from 'components/forms'
import { IAutocomplete } from '../CarrierEntryForm/CarrierInfo'

interface DriverInfoProps {
  children: ReactNode
}

const DriverInfo: FC<DriverInfoProps> = ({ children }) => (
  <section className='mt4'>
    <div className='b mb4'>Driver Information</div>
    {children}
  </section>
)

export default DriverInfo

interface IDriverSearchProps {
  changeDriverHandler: (selected: IAutocomplete) => void
  carrierId?: string
  value?: string
}

export const DriverSelect = memo<IDriverSearchProps>(
  ({ carrierId, changeDriverHandler, value }) => (
    <Autocomplete
      id='driver'
      label='Driver'
      type='driver'
      companyId={carrierId}
      value={value}
      onChange={changeDriverHandler}
      dataTest='select-driver'
      placeholder='Search driver by name'
    />
  )
)

interface IDriverField {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
  value: string
  vinError?: string
}

export const DriverTractorVin = memo<IDriverField>(({ onBlur, onChange, value, vinError }) => (
  <div className='dialog-medium'>
    <TextInput
      value={value}
      name='vin'
      dataTest='input-vin'
      label='Tractor VIN'
      onChange={onChange}
      onBlur={onBlur}
      minLength={4}
      maxLength={6}
      clearable={false}
      invalid={Boolean(vinError)}
      validationMessage={vinError}
      // TODO: To determine logic
      // required
      // helperMessage='This shipment requires a tractor VIN.'
    />
  </div>
))
